// hooks/useSidebarOffset.js
import { useEffect, useMemo, useState } from "react";
import { CHAT_DRAWER_WIDTH } from "../components/Chat/Sidebar";

const DATA_PROCESSES_WIDTH = 280; // width of your right-side "Data Processes" panel

export default function useSidebarOffset(isSidebarOpen, isDataProcessesOpen) {
  const [viewportWidth, setViewportWidth] = useState(() => {
    if (typeof window === "undefined") return CHAT_DRAWER_WIDTH;
    return window.innerWidth;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => setViewportWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return useMemo(() => {
    const desktop = viewportWidth >= 900; // match Sidebar breakpoint

    const leftWidth =
      isSidebarOpen && desktop
        ? CHAT_DRAWER_WIDTH
        : 0;

    const rightWidth = isDataProcessesOpen && desktop ? DATA_PROCESSES_WIDTH : 0;

    // Positive => shift right (left drawer open)
    // Negative => shift left (right drawer open)
    // Both open => left - right
    return leftWidth - rightWidth;
  }, [isSidebarOpen, isDataProcessesOpen, viewportWidth]);
}
